import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import MuiToggleButtonGroup from "Components/MuiToggleButtonGroup/MuiToggleButtonGroup";
import {
  toggleNAluminiumUpvc,
  toggleNLolayiKeshoyi,
} from "Constants/Constants";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import {
  getBrandYaragh,
  getColor,
  getFrame,
  getGroupProfile,
  getShishe,
  getShisheGroup,
  getTori,
  getTypeColor,
  postInsertOlgu,
  changeOlguSearch,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import * as R from "ramda";
import showNotify from "Helpers/Notify";
import { DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { GET_OLGU_AGAIN } from "Stores/actionTypes";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";

function NewOlguDialog({ toggle, setToggle, setProfile, setChanges }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    dasteProfileListWithTypeStruct,
    frameList,
    typeColorList,
    colorList,
    brandYaraghList,
    toriList,
    shisheGroupList,
    shisheList,
  } = useSelector((state) => ({
    dasteProfileListWithTypeStruct:
      state.pattern.dasteProfileListWithTypeStruct,
    frameList: state.pattern.frameList,
    typeColorList: state.pattern.typeColorList,
    colorList: state.pattern.colorList,
    brandYaraghList: state.pattern.brandYaraghList,
    toriList: state.pattern.toriList,
    shisheGroupList: state.pattern.shisheGroupList,
    shisheList: state.pattern.shisheList,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);

  const [nameG, setNameG] = useState({
    dasteProfile: "",
    frame: "",
    typeColor: "",
    color: "",
    brandYaragh: "",
  });
  const [controls, setControls] = useSetState({
    selectType: {
      type: "toggle",
      arrayItems: toggleNLolayiKeshoyi,
      value: toggleNLolayiKeshoyi[0],
      col: {
        sm: 6,
        xs: 12,
      },
    },
    struct: {
      type: "toggle",
      arrayItems: toggleNAluminiumUpvc,
      value: toggleNAluminiumUpvc[0],
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    dasteProfile: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    frame: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    typeColor: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    color: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    brandYaragh: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    tori: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    shisheGroup: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    shishe: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 6,
        xs: 12,
      },
    },
    name: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
      col: {
        sm: 12,
        xs: 12,
      },
    },
  });

  const onClear = () => {
    setFormValid({
      name: false,
      dasteProfile: false,
      frame: false,
      typeColor: false,
      color: false,
      brandYaragh: false,
      tori: false,
      shisheGroup: false,
      shishe: false,
    });
    setControls({
      selectType: {
        value: toggle === 1 ? toggleNLolayiKeshoyi[0] : toggleNLolayiKeshoyi[1],
      },
    });
    setControls({ struct: { value: toggleNAluminiumUpvc[0] } });
    setControls({ dasteProfile: { value: "" } });
    setControls({ frame: { value: "" } });
    setControls({ typeColor: { value: "" } });
    setControls({ color: { value: "" } });
    setControls({ brandYaragh: { value: "" } });
    setControls({ tori: { value: "" } });
    setControls({ shisheGroup: { value: "" } });
    setControls({ shishe: { value: "" } });
    setControls({ name: { value: "" } });
    setCheckValid(false);
    setNameG({
      dasteProfile: "",
      frame: "",
      typeColor: "",
      color: "",
      brandYaragh: "",
    });
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: value.length === 0 ? false : validation }));
  };

  const defName = (control, value) => {
    const _nameG = { ...nameG, [control]: value };
    let _name =
      [_nameG.dasteProfile !== "" ? _nameG.dasteProfile + " - " : ""] +
      [_nameG.frame !== "" ? _nameG.frame + " - " : ""] +
      [_nameG.typeColor !== "" ? _nameG.typeColor + " - " : ""] +
      [_nameG.color !== "" ? _nameG.color + " - " : ""] +
      [_nameG.brandYaragh !== "" ? _nameG.brandYaragh : ""];
    if (_name.lastIndexOf("-") === _name.length - 2)
      _name = _name.substring(0, _name.lastIndexOf("-"));
    setNameG(_nameG);
    setValue("name", _name, true);
  };

  const onChangeToggle = async (name, key, value) => {
    setControls({ [name]: { value: value } });
    setLoading(true);
    if (name === "struct") {
      try {
        const paramsProfile = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdStruct: value.value === "upvc" ? 1 : 2,
          IdType: controls.selectType.value.value === "lolayi" ? 1 : 2,
        };
        await dispatch(getGroupProfile(paramsProfile));
        const paramsStruct = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdStruct: value.value === "upvc" ? 1 : 2,
        };
        await dispatch(getTypeColor(paramsStruct));
        await dispatch(getBrandYaragh(paramsStruct));
        setControls({ color: { value: "" } });
        setControls({ color: { selectItems: [] } });
        setControls({ frame: { value: "" } });
        setControls({ frame: { selectItems: [] } });
        setControls({ dasteProfile: { value: "" } });
        setControls({ typeColor: { value: "" } });
        setControls({ brandYaragh: { value: "" } });
        setNameG({
          dasteProfile: "",
          frame: "",
          typeColor: "",
          color: "",
          brandYaragh: "",
        });
        setValue("name", "", false);
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (name === "selectType") {
      try {
        const paramsProfile = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdStruct: controls.struct.value.value === "upvc" ? 1 : 2,
          IdType: value.value === "lolayi" ? 1 : 2,
        };
        await dispatch(getGroupProfile(paramsProfile));
        setControls({ color: { value: "" } });
        setControls({ color: { selectItems: [] } });
        setControls({ frame: { value: "" } });
        setControls({ frame: { selectItems: [] } });
        setControls({ dasteProfile: { value: "" } });
        setControls({ typeColor: { value: "" } });
        setControls({ brandYaragh: { value: "" } });
        setNameG({
          dasteProfile: "",
          frame: "",
          typeColor: "",
          color: "",
          brandYaragh: "",
        });
        setValue("name", "", false);
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    setLoading(false);
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
    defName(controlName, value.Name);
    setControls({ [controlName]: { value: value } });
    if (controlName === "dasteProfile") {
      try {
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGroupProfile: value.value,
        };
        await dispatch(getFrame(params));
        setControls({ frame: { value: "" } });
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (controlName === "typeColor") {
      try {
        const paramsColor = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdTypeColor: value.value,
        };
        await dispatch(getColor(paramsColor));
        setControls({ color: { value: "" } });
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
    if (controlName === "shisheGroup") {
      try {
        const paramsShishe = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          IdGroupProduct: value.value,
        };
        await dispatch(getShishe(paramsShishe));
        setControls({ shishe: { value: "" } });
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
  };

  const handleDialog = () => {
    if (openDialog) {
      const tvalue = controls.selectType.value.value === "lolayi" ? 1 : 2;
      const pvalue =
        controls.dasteProfile.value !== "" ? controls.dasteProfile.value : null;
      let changes = { toggle: false, profile: false };
      if (tvalue !== toggle) changes.toggle = true;
      if (pvalue) changes.profile = true;
      setChanges(changes);
      setToggle(tvalue);
      setProfile(pvalue);
    }
    setOpenDialog(!openDialog);
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    const {
      dasteProfile,
      frame,
      typeColor,
      color,
      brandYaragh,
      tori,
      shishe,
      name,
    } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        const IdNet = tori.value.value !== undefined ? +tori.value.value : -1;
        const IdGroupProfile =
          dasteProfile.value.value !== undefined
            ? +dasteProfile.value.value
            : -1;
        const IdColor =
          color.value.value !== undefined ? +color.value.value : -1;
        const IdFitting =
          brandYaragh.value.value !== undefined ? +brandYaragh.value.value : -1;
        const IdGlass =
          shishe.value.value !== undefined ? +shishe.value.value : -1;
        const IdPartMainFrame =
          frame.value.IdPartMain !== undefined ? +frame.value.IdPartMain : -1;
        const IdPartRefFrame =
          frame.value.IdPartRef !== undefined ? +frame.value.IdPartRef : -1;
        const IdTypeColor =
          typeColor.value.value !== undefined ? +typeColor.value.value : -1;
        const Name = name.value;
        if (
          IdNet !== -1 &&
          IdGroupProfile !== -1 &&
          IdColor !== -1 &&
          IdFitting !== -1 &&
          IdGlass !== -1 &&
          IdPartMainFrame !== -1 &&
          IdPartRefFrame !== -1 &&
          IdTypeColor !== -1 &&
          Name !== ""
        ) {
          const data = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdNet,
            IdGroupProfile,
            IdColor,
            IdFitting,
            IdGlass,
            IdPartMainFrame,
            IdPartRefFrame,
            IdTypeColor,
            Name,
          };
          await dispatch(postInsertOlgu(data));
          handleDialog();
          dispatch(changeOlguSearch({ Name: "" }));
          dispatch({ type: GET_OLGU_AGAIN, data: true });
        } else {
          showNotify({
            text: t("invalidInformation"),
            customClass: "error",
          });
        }
      } catch (e) {
        console.log('onSubmit', e);
      }
    } else {
      setCheckValid(true);
      showNotify({
        text: t("invalidInformation"),
        customClass: "error",
      });
    }
    setLoading(false);
  };

  const onEnter = async () => {
    onClear();
    // const { struct, selectType } = controls;
    try {
      setLoading(true);
      const IdStruct = 1; //struct.value === "upvc" ? 1 : 2;
      const IdType = toggle; //selectType.value === "lolayi" ? 1 : 2;
      const paramsProfile = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdStruct,
        IdType,
      };
      await dispatch(getGroupProfile(paramsProfile));

      const paramsStruct = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdStruct,
      };
      await dispatch(getTypeColor(paramsStruct));
      await dispatch(getBrandYaragh(paramsStruct));

      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
      };
      await dispatch(getShisheGroup(params));
      await dispatch(getTori(params));

      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  useEffect(() => {
    setControls({
      dasteProfile: { selectItems: dasteProfileListWithTypeStruct },
    });
    setControls({ frame: { selectItems: frameList } });
    setControls({ typeColor: { selectItems: typeColorList } });
    setControls({ color: { selectItems: colorList } });
    setControls({ brandYaragh: { selectItems: brandYaraghList } });
    setControls({ tori: { selectItems: toriList } });
    setControls({ shisheGroup: { selectItems: shisheGroupList } });
    setControls({ shishe: { selectItems: shisheList } });
  }, [
    dasteProfileListWithTypeStruct,
    frameList,
    typeColorList,
    colorList,
    brandYaraghList,
    toriList,
    shisheGroupList,
    shisheList,
  ]);

  return (
    <>
      <MuiButton
        loading={loading}
        color="primary"
        title={<Translator id={"newPattern"} />}
        onClick={handleDialog}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
          <DialogContent>
            {!loading ? (
              <Grid container spacing={2}>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid
                      item
                      sm={controls[key].col.sm}
                      xs={controls[key].col.xs}
                      key={key + index}
                    >
                      {controls[key].type === "toggle" && (
                        <MuiRadioGroup
                          name={key}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          items={controls[key].arrayItems}
                          onChange={onChangeToggle}
                          translate={true}
                          className="horizontalRadio"
                        />
                      )}
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          helperText={checkValid && !formValid[key]}
                          onChange={autoCompleteHandler}
                        />
                      )}
                      {controls[key].type === "text" && (
                        <Input
                          setValue={setValue.bind(this)}
                          value={controls.name.value}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          checkValid={checkValid && !formValid[key]}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={12} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              onClick={onFinish}
              title={<Translator id="button_save" />}
              disabled={loading}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
              disabled={loading}
            />
          </DialogActions>
      </Dialog>
    </>
  );
}

export default NewOlguDialog;
